import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { teamService } from '../../services/team'
import { setUpperPopup } from '../../store/reducers/general'
import { editTeam } from '../../store/reducers/user'
import { departmentsTranslations } from '../../services/data'
import { CreateDepartment } from '../../cmps/team/create-department'
import { rolesColors } from '../../services/data'
import { ReassignMissionsDepartment } from './reassign-missions-department.jsx'
import { AddMemberDepartment } from './add-member-department.jsx'
import { Login } from '../../pages/login.jsx'

export function Departments({ teamVideos }) {
    const dispatch = useDispatch()
    const user = useSelector(state => state.user)
    const team = useSelector(state => state.user.currentTeam)
    const [selectedDepartment, setSelectedDepartment] = useState('')
    const [createDepartmentOpen, setCreateDepartmentOpen] = useState(false)
    const [popupDepartment, setPopupDepartment] = useState('')
    const userRoles = team?.members?.find(member => member._id === user._id)?.roles || []
    const isAdmin = userRoles.includes('admin')

    const createDepartment = async (name, type, members) => {
        try {
            const department = await teamService.createDepartment({ name, type, members }, team._id)
            const newTeam = { ...team, departments: { ...team.departments, [department.name]: department } }
            dispatch(editTeam(newTeam))
            setCreateDepartmentOpen(false)
        }
        catch (err) {
            if (err.message.includes('405')) return dispatch(setUpperPopup('department-already-exists'))
            dispatch(setUpperPopup('errorServer'))
        }
    }

    const deleteDepartment = async (name, videos) => {
        try {
            await teamService.deleteDepartment(name, team._id, videos)
            let newDepartments = { ...team.departments }
            delete newDepartments[name]
            const newTeam = { ...team, departments: newDepartments }
            dispatch(editTeam(newTeam))
            dispatch(setUpperPopup('department-deleted'))
        }
        catch (err) {
            console.log(err)
            dispatch(setUpperPopup('errorServer'))
        }
    }

    const removeMember = async (memberId, departmentName) => {
        try {
            await teamService.removeMemberFromDepartment(memberId, team._id, departmentName)
            let department = structuredClone(team.departments[departmentName])
            delete department.members[memberId]
            dispatch(editTeam({ ...team, departments: { ...team.departments, [departmentName]: department } }))
            dispatch(setUpperPopup('member-removed'))
        }
        catch (err) {
            console.log(err)
            dispatch(setUpperPopup('errorServer'))
        }
    }

    const addMembers = async (members, departmentName) => {
        try {
            const newMembers = await teamService.addMembersToDepartment(members, team._id, departmentName)
            let department = structuredClone(team.departments[departmentName])
            newMembers.forEach(member => department.members[member._id] = member)
            dispatch(editTeam({ ...team, departments: { ...team.departments, [departmentName]: department } }))
            dispatch(setUpperPopup('members-added'))
        }
        catch (err) {
            console.log(err)
            dispatch(setUpperPopup('errorServer'))
        }
    }


    if (!user._id) return <Login />

    const departments = Object.values(team.departments || {})

    return <div className="profile team">
        {departments.length === 0 && <p>לא קיימות מחלקות בצוות שלך</p>}
        {isAdmin && <h2 className='clickable noselect btn arise' onClick={() => setCreateDepartmentOpen(!createDepartmentOpen)}>{createDepartmentOpen ? 'סגור' : 'מחלקה חדשה'}<span className='material-symbols-outlined'>{createDepartmentOpen ? 'expand_less' : 'add'}</span></h2>}
        {createDepartmentOpen && <CreateDepartment
            createDepartment={createDepartment}
            allMembers={team.members} />}

        {departments.map(department => <div className="department-card" key={department.name}>
            <div className="department-header">
                <h2 className="department-title">
                    {department.name} <span className="department-type">({departmentsTranslations[department.type]})</span>
                </h2>
                <p
                    className="department-tasks clickable"
                    onClick={() => { setSelectedDepartment(department); setPopupDepartment('view') }}
                >
                    {teamVideos[department.name]?.length || 0} משימות
                </p>
            </div>

            <div className="department-members-section">
                <h3 className="members-title">חברים במחלקה</h3>
                <div className="members-list">
                    {Object.values(department.members).map((member) => (
                        <div className="member-item" key={member._id}>
                            <p className="member-name">{member.name}</p>
                            {isAdmin && (
                                <span
                                    className="member-remove material-symbols-outlined clickable"
                                    onClick={() => removeMember(member._id, department.name)}
                                >
                                    delete
                                </span>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            {isAdmin && (
                <div className="department-actions">
                    <AddMemberDepartment
                        addMember={addMembers}
                        allMembers={team.members}
                        department={department}
                    />
                    <p
                        className="delete-department-btn clickable noselect btn arise"
                        onClick={() => {
                            setSelectedDepartment(department);
                            setPopupDepartment('delete');
                        }}
                    >
                        מחק מחלקה
                    </p>
                </div>
            )}
        </div>
        )}

        {popupDepartment && <ReassignMissionsDepartment
            closePopup={() => setPopupDepartment('')}
            department={selectedDepartment}
            vids={teamVideos[selectedDepartment.name]}
            team={team}
            deleteDepartment={deleteDepartment}
            transfer={popupDepartment === 'delete'} />}
    </div>
}